import { atom } from "recoil";

export const myTimeMessageState = atom({
  key: "myTimeMessageState",
  default: "",
});
